import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-ded775be"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "container px-0 support-page-height" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("main", { class: "col-md-9 col-lg-10 px-md-4" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "container py-3" }, [
    /*#__PURE__*/_createElementVNode("div", { class: "row" }, [
      /*#__PURE__*/_createElementVNode("div", { class: "my-2" })
    ])
  ])
], -1))
const _hoisted_3 = [
  _hoisted_2
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, _hoisted_3))
}